import React, { createContext, useContext, useState, ReactNode, useMemo } from "react";
import {
  SearchFilterInput,
  //SearchFilterTypes
} from "@thenounproject/lingo-core";

export type ProductPreset = {
  name: string;
  filters: SearchFilterInput[];
};

type ProductsContextType = {
  appliedFilters: SearchFilterInput[];
  setFilters: (filters: SearchFilterInput[]) => void;
  addFilter: (filter: SearchFilterInput) => void;
  removeFilter: (index: number) => void;
  presetViews: ProductPreset[];
  activePreset: ProductPreset | null;
  sort: string;
  setSortBy: (sort: string) => void;
};

const ProductsContext = createContext<ProductsContextType | undefined>(undefined);

// const PRESET_VIEWS: ProductPreset[] = [
//   {
//     name: "Recently added",
//     filters: [
//       {
//         type: SearchFilterTypes.date,
//         filter_type: "added",
//         display: "Last 7 days",
//         value: "last-7-days",
//       },
//     ],
//   },
//   {
//     name: "Recently updated",
//     filters: [
//       {
//         type: SearchFilterTypes.date,
//         filter_type: "updated",
//         display: "Last 7 days",
//         value: "last-7-days",
//       },
//     ],
//   },
// ];
const PRESET_VIEWS: ProductPreset[] = [];

export const ProductsProvider = ({ children }: { children: ReactNode }) => {
  const [appliedFilters, setAppliedFilters] = useState<SearchFilterInput[]>([]);
  const [sort, setSort] = useState<string>("recent");

  const setFilters = (filters: SearchFilterInput[]) => {
    setAppliedFilters(filters);
  };

  const addFilter = (filter: SearchFilterInput) => {
    setAppliedFilters([...appliedFilters, filter]);
  };

  const removeFilter = (index: number) => {
    setAppliedFilters(appliedFilters.filter((_, i) => i !== index));
  };

  const setSortBy = (newSort: string) => {
    setSort(newSort);
  };

  const activePreset = useMemo(() => {
    if (!appliedFilters.length) return null;

    return (
      PRESET_VIEWS.find(preset => {
        if (preset.filters.length !== appliedFilters.length) return false;
        return preset.filters.every((filter, index) => {
          const appliedFilter = appliedFilters[index];
          return (
            filter.type === appliedFilter.type &&
            filter.value === appliedFilter.value &&
            filter.display === appliedFilter.display &&
            filter.filterType === appliedFilter.filterType
          );
        });
      }) || null
    );
  }, [appliedFilters]);

  const value = {
    appliedFilters,
    setFilters,
    addFilter,
    removeFilter,
    presetViews: PRESET_VIEWS,
    activePreset,
    sort,
    setSortBy,
  };

  return <ProductsContext.Provider value={value}>{children}</ProductsContext.Provider>;
};

export const useProductsContext = () => {
  const context = useContext(ProductsContext);
  if (context === undefined) {
    throw new Error("useProductsContext must be used within a ProductsProvider");
  }
  return context;
};
